module.exports = __webpack_public_path__ + "media/large/real_estate_townhomes_sale-c22cf2e1.jpeg";